module.exports = __webpack_public_path__ + "img/PHX-Logo.53712228.png";